import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-cb7d96ea")
const _hoisted_1 = { class: "ticket" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "uploader" }
const _hoisted_4 = {
  key: 0,
  class: "file"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-image" }, null, -1)
const _hoisted_6 = { class: "file__name" }
const _hoisted_7 = { class: "uploader__open_btn" }
const _hoisted_8 = { class: "gallery" }
const _hoisted_9 = ["src"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.ticket || _ctx.requestPending)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2))
      : (_openBlock(), _createBlock(_component_Fieldset, {
          key: 1,
          legend: "Gallery",
          class: "p-mt-3"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              (_ctx.selectedFile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.fileName), 1),
                    (!_ctx.isNew)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          icon: "pi pi-upload",
                          class: "file__action",
                          onClick: _ctx.onUpload
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.uploadInProgress)
                ? (_openBlock(), _createBlock(_component_ProgressBar, {
                    key: 1,
                    class: "uploader__progress",
                    mode: "indeterminate",
                    style: {"height":".5em"}
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_Button, {
                  icon: "pi pi-plus",
                  label: "Add photo",
                  onClick: _ctx.onAddPhoto
                }, null, 8, ["onClick"]),
                _createElementVNode("input", {
                  type: "file",
                  hidden: "",
                  ref: "file_input",
                  accept: "image/*",
                  onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFilesSelect && _ctx.onFilesSelect(...args)))
                }, null, 544)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "gallery__item",
                  key: file.id
                }, [
                  _createElementVNode("img", {
                    src: file.file_path_url
                  }, null, 8, _hoisted_9),
                  _withDirectives(_createVNode(_component_Button, {
                    icon: "pi pi-times",
                    class: "p-button-danger p-button-rounded gallery__delete_btn",
                    onClick: ($event: any) => (_ctx.onRemoveFile(file.id))
                  }, null, 8, ["onClick"]), [
                    [
                      _directive_tooltip,
                      _ctx.$t('remove'),
                      void 0,
                      { bottom: true }
                    ]
                  ])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }))
  ]))
}